import React from 'react';
import Helmet from 'react-helmet';
import strings from 'app/strings';

import './error.less';

const Error = () => (
  <div className='Error'>
    <Helmet title='Error Loading Page' />
    <h2 className='h2'>{strings.ERROR_HEADER}</h2>
    <h4 className='h3'>{strings.ERROR_SUB}</h4>
  </div>
);

Error.propTypes = {};

export default Error;



// WEBPACK FOOTER //
// ./app/components/error.jsx